<template>
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.889648 13.183C0.889648 9.34084 0.889648 5.49871 0.889648 1.65613C0.898324 1.63957 0.912205 1.62435 0.914807 1.60689C1.01674 0.89469 1.65177 0.239787 2.5336 0.240235C7.77125 0.243368 13.0093 0.239787 18.247 0.24874C18.4925 0.24874 18.7593 0.304695 18.9792 0.413473C19.5921 0.717871 19.8883 1.24878 19.8883 1.95292C19.8883 3.70813 19.8883 5.4629 19.8883 7.21811C19.8883 9.10717 19.8857 10.9962 19.8896 12.8853C19.8909 13.4659 19.6927 13.939 19.2433 14.2976C18.9232 14.5532 18.5545 14.6248 18.1637 14.6248C16.4942 14.6248 14.8242 14.6248 13.1546 14.6248C13.0826 14.6248 13.0106 14.6248 12.9096 14.6248C12.9373 14.7967 12.9391 14.9471 12.9877 15.0792C13.136 15.4834 13.2948 15.8841 13.4631 16.2798C13.6782 16.7865 13.4071 17.2319 12.8662 17.2382C12.5383 17.2422 12.2108 17.2391 11.8829 17.2391C10.5595 17.2391 9.23606 17.2413 7.91266 17.2377C7.37176 17.2364 7.09285 16.7843 7.31407 16.2811C7.42902 16.0201 7.56348 15.7668 7.65891 15.4986C7.75477 15.2283 7.81333 14.9436 7.89921 14.6248C7.76995 14.6248 7.69751 14.6248 7.62551 14.6248C5.95597 14.6248 4.28599 14.623 2.61645 14.6257C2.15493 14.6266 1.73808 14.5134 1.39324 14.1776C1.11347 13.905 0.962086 13.5657 0.889648 13.1825V13.183ZM10.389 10.6981C12.9738 10.6981 15.5585 10.6981 18.1433 10.6981C18.5346 10.6981 18.6244 10.6063 18.6244 10.2043C18.6244 7.4858 18.6244 4.76726 18.6244 2.04872C18.6244 1.64852 18.5289 1.5487 18.1438 1.5487C12.9742 1.5487 7.80465 1.5487 2.63553 1.5487C2.25035 1.5487 2.15449 1.64852 2.15449 2.04827C2.15449 4.76681 2.15449 7.48535 2.15449 10.2039C2.15449 10.6059 2.24385 10.6981 2.6351 10.6981C5.21988 10.6981 7.80465 10.6981 10.3894 10.6981H10.389Z"
      :fill="color"
    />
  </svg>
</template>
  
<script>
export default {
  name: "WindowsGreyIcon",
  props: {
    color: {
      type: String,
      required: false,
      default: "#6D7492"
    }
  }
};
</script>